export default "__VITE_ASSET__D5HnLW1w__"